import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';
import Transition from '@ember/routing/-private/transition';
import AuthService from 'cio/services/auth';
import AssetsController from 'cio/pods/assets/controller';
import { ASSETS_DEFAULT_SORT_BY, ASSETS_DEFAULT_ASC } from 'cio/models/asset';

export default class AssetsRoute extends Route {
  @service features!: FeaturesService;
  @service auth!: AuthService;

  setupController(controller: AssetsController, model: any, transition: Transition) {
    super.setupController(controller, model, transition);

    let { page, folderId } = this.paramsFor(this.fullRouteName) as { page: string; folderId: string | null };

    if (page != null && (!Number.isInteger(page) || parseInt(page) < 1)) {
      controller.set('page', 1);
      this.router.transitionTo(this.routeName, { queryParams: { page: 1, folderId } });
    }

    if (folderId != null && !Number.isInteger(Number(folderId))) {
      controller.set('folderId', null);
      this.router.transitionTo(this.routeName, { queryParams: { page, folderId: null } });
      return;
    }
  }

  resetController(controller: AssetsController, isExiting: boolean, transition: any) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.setProperties({
        folderId: null,
        page: 1,
        sort: ASSETS_DEFAULT_SORT_BY,
        asc: ASSETS_DEFAULT_ASC,
        search: '',
      });
    }
  }

  crumb() {
    return {
      name: 'Assets',
      path: 'assets',
    };
  }
}
